import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterCommonTopicsClick } from "@faire/web-api--source/events/helpCenter/click/commonTopics";
import articlePage from "@faire/web-api--source/routes/www/support/articles/articleId";
import React, { type JSX } from "react";

import { EndWithComma } from "./CommonTopics";

export const BrandTopics: React.FC = () => {
  const articles = useArticles();
  return (
    <Typography>
      <StrictLocalMsg
        defaultMessage="Common topics: <OrderStatusLinkFormatting>order status</OrderStatusLinkFormatting> <OrderNotificationsLinkFormatting>order notifications</OrderNotificationsLinkFormatting> <AcceptingOrderLinkFormatting>accepting an order</AcceptingOrderLinkFormatting>"
        description={{
          text: "Common topics in the help center",
          img: "https://cdn.faire.com/fastly/52cb93c22e6cfef999f8d23bb6649dcde090a56328153732e0a4346e9f0bf8c4.png",
        }}
        values={{
          OrderStatusLinkFormatting: LinkFormatting(
            articlePage(
              `${articles.FulfillingOrders.UNDERSTAND_ORDER_STATUS.id}`
            )
          ),
          OrderNotificationsLinkFormatting: LinkFormatting(
            articlePage(`${articles.MyOrders.HOW_AM_I_NOTIFIED_NEW_ORDERS.id}`)
          ),
          AcceptingOrderLinkFormatting: LinkFormatting(
            articlePage(`${articles.FulfillingOrders.ACCEPTING_ORDER.id}`)
          ),
        }}
      />
    </Typography>
  );
};

const LinkFormatting = (linkTo: string) =>
  function (chunks: JSX.Element) {
    const retailerToken = getRetailerToken() ?? "";
    const brandToken = getBrandToken() ?? "";

    return (
      <EndWithComma>
        <Button
          linkTo={linkTo}
          variant="tertiary"
          onClick={() =>
            trackHelpCenterCommonTopicsClick(
              retailerToken,
              brandToken,
              CustomerTypes.BRAND,
              `${chunks}`,
              linkTo
            )
          }
        >
          {chunks}
        </Button>
      </EndWithComma>
    );
  };
